export const GET_EMPLOYEE_ROLES_REQUESTED = 'GET_EMPLOYEE_ROLES_REQUESTED'
export const GET_EMPLOYEE_ROLES_SUCCEEDED = 'GET_EMPLOYEE_ROLES_SUCCEEDED'
export const GET_EMPLOYEE_ROLES_FAILED = 'GET_EMPLOYEE_ROLES_FAILED'
export const CREATE_EMPLOYEE_ROLE_REQUESTED = 'CREATE_EMPLOYEE_ROLE_REQUESTED'
export const CREATE_EMPLOYEE_ROLE_SUCCEEDED = 'CREATE_EMPLOYEE_ROLE_SUCCEEDED'
export const CREATE_EMPLOYEE_ROLE_FAILED = 'CREATE_EMPLOYEE_ROLE_FAILED'
export const UPDATE_EMPLOYEE_ROLE_REQUESTED = 'UPDATE_EMPLOYEE_ROLE_REQUESTED'
export const UPDATE_EMPLOYEE_ROLE_SUCCEEDED = 'UPDATE_EMPLOYEE_ROLE_SUCCEEDED'
export const UPDATE_EMPLOYEE_ROLE_FAILED = 'UPDATE_EMPLOYEE_ROLE_FAILED'
